// create_story.js

import React, { useState } from "react";
import "./create_story.scss";

const CreateStory = () => {
  const [topic, setTopic] = useState("");
  const [wordCount, setWordCount] = useState("300");
  const [story, setStory] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const API_URL = "https://api.zulluai.com/api/groq/story";

  const generateStory = async () => {
    if (!topic.trim()) {
      setError("Please enter a story prompt");
      return;
    }

    setError("");
    setLoading(true);
    setStory("");

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          topic: topic.trim(),
          wordCount: wordCount,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setStory(data.story);
      } else {
        throw new Error(data.message || "Failed to generate story");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(story);
  };

  return (
    <div className="story-page">
      <div className="story-card">
        <h1>ZulluAI Story Studio</h1>

        <label>Story Prompt</label>
        <textarea
          placeholder="Write a prompt for your story..."
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          rows="4"
        />

        <label>Word Count</label>
        <select
          value={wordCount}
          onChange={(e) => setWordCount(e.target.value)}
        >
          <option value="100">100</option>
          <option value="300">300</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
          <option value="1500">1500</option>
          <option value="2000">2000</option>
          <option value="2500">2500</option>
          <option value="3000">3000</option>
        </select>

        <button onClick={generateStory} disabled={loading}>
          {loading ? "Generating..." : "Generate Story"}
        </button>

        {error && <div className="error">{error}</div>}

        {loading && <div className="loader"></div>}

        {story && (
          <div className="story-result">
            <div className="result-header">
              <h3>Generated Story</h3>
              <button className="copy-btn" onClick={copyToClipboard}>
                Copy
              </button>
            </div>
            <p>{story}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateStory;
